/**
 * cart-quantity-lock.js
 *
 * The custom patch calculator sends Shopify a "quantity" that actually
 * represents the total price in cents (a workaround needed because standard
 * Shopify checkout can't take a fully custom price per line). That raw number
 * (e.g. 14490) is correct for billing but confusing to show a customer.
 *
 * This script finds any cart line that has an "Actual Quantity Ordered"
 * property (set by the calculator) and replaces the visible quantity
 * stepper with a plain, correct, non-editable label — e.g. "10 pcs".
 *
 * IMPORTANT: it does not change what Shopify charges — the real cents-based
 * quantity is still what's stored in the cart. It only fixes what customer
 * sees, and stops them from accidentally clicking +/- (which would multiply
 * the price incorrectly, since each "unit" here is worth 1 cent).
 *
 * HOW TO ADD THIS TO YOUR THEME:
 * Online Store → Themes → Edit code → Assets → "Add a new asset" → name it
 * cart-quantity-lock.js → paste this file's contents → Save.
 * Then open your cart template file (often sections/main-cart-items.liquid
 * or templates/cart.liquid) and add this line near the bottom, before
 * {% endif %}/{% endsection %}:
 *   <script src="{{ 'cart-quantity-lock.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  var LOCKED_FLAG = 'patchQtyLocked';

  function lockPatchLines() {
    // Broad net: works across most themes since it doesn't rely on exact
    // class names, only on finding the text this calculator always writes.
    var allNodes = document.querySelectorAll(
      'tr, li, .cart-item, [class*="cart-item"], [class*="CartItem"], [class*="cart__row"]'
    );

    allNodes.forEach(function (row) {
      if (row.dataset[LOCKED_FLAG]) return;

      var text = row.textContent || '';
      if (text.indexOf('Actual Quantity Ordered') === -1) return;

      var match = text.match(/Actual Quantity Ordered:\s*([\d,]+)\s*pcs/i);
      if (!match) return;
      var realQty = match[1];

      // Find the interactive quantity control inside this specific row only.
      var qtyInput = row.querySelector(
        'input[type="number"], input[name="updates[]"], input[name*="quantity" i]'
      );
      if (!qtyInput) return;

      var wrapper =
        qtyInput.closest('[class*="quantity" i]') || qtyInput.parentElement;
      if (!wrapper) return;

      // Also hide +/- stepper buttons and the trash/remove-quantity controls
      // that live in the same wrapper, replacing everything with static text.
      var label = document.createElement('span');
      label.textContent = realQty + ' pcs';
      label.style.fontWeight = '600';
      label.setAttribute('aria-label', 'Quantity: ' + realQty + ' pieces');

      wrapper.innerHTML = '';
      wrapper.appendChild(label);

      row.dataset[LOCKED_FLAG] = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', lockPatchLines);

  // Re-apply after AJAX cart re-renders (covers most theme cart-update events).
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated'].forEach(
    function (evt) {
      document.addEventListener(evt, lockPatchLines);
    }
  );

  // Fallback for themes that re-render the cart without firing a custom event.
  var target =
    document.querySelector('cart-items') ||
    document.querySelector('[id*="cart" i]') ||
    document.body;
  if (target) {
    new MutationObserver(function () {
      lockPatchLines();
    }).observe(target, { childList: true, subtree: true });
  }

  lockPatchLines();
})();